import React, { Component } from 'react';
import { Container, Grid } from 'semantic-ui-react'

import Wrapper from '../wrapper';

import ResultsPane from '../../components/resultsPane';
import CaseStudyPane from '../../components/caseStudyPane';
import ScenarioCard from '../../components/scenarioCard';

import PROJECTIONS from '../../data/sample-projections';

import styles from './styles.module.scss';

const SCENARIOS = [
  {
    title: `Business as Usual (BAU)`,
    scenarioKey: 'bau',
    hasTabs: false,
    projection: PROJECTIONS[0],
  },
  {
    title: `Scenario 1`,
    scenarioKey: 'primary',
    hasTabs: true,
    projection: PROJECTIONS[1],
  },
  {
    title: `Scenario 2`,
    scenarioKey: 'secondary',
    hasTabs: true,
    projection: PROJECTIONS[1],
  }
]

class ModelResults extends Component {
  render() {
    return (
      <Wrapper>
        <ResultsPane />
        <Container>
          <Grid columns={1}>
            <Grid.Row>
              <Grid.Column>
                <p className={styles.scenarioLead}>Based on your city and chosen projects, we projected what your city would look like without any chosen projects compared to various scenarios.</p>
              </Grid.Column>
            </Grid.Row>
          </Grid>

        </Container>
        <Container className={styles.scenarioRow}>
          <Grid columns={3}>
          <Grid.Row>
            {SCENARIOS.map(card => (
                <Grid.Column
                  key={card.title}
                >
                  <ScenarioCard
                    title={card.title}
                    scenarioKey={card.scenarioKey}
                    description={card.description}
                    hasTabs={card.hasTabs}
                    projection={card.projection}
                    goals={card.goals}
                  />
                </Grid.Column>
              ))
            }
            </Grid.Row>
          </Grid>
        </Container>
        <CaseStudyPane/>
      </Wrapper>
    );
  }
}

export default ModelResults;



// WEBPACK FOOTER //
// ./src/pages/modelResults/index.js